export default "__VITE_ASSET__BM2$QlBm__"